import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DataService} from '../../_services/data.service';
import {FlatTestComponent} from '../buildings/flat-test/flat-test.component';
import {anim, slideRight, slideUp} from 'src/app/animations';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-flat-propeties-onthe-fly',
    templateUrl: './flat-propeties-onthe-fly.component.html',
    styleUrls: ['./flat-propeties-onthe-fly.component.scss'],
    animations: [
        anim,
        slideRight,
        slideUp
    ]
})
export class FlatPropetiesOntheFlyComponent implements OnInit {
    mainSpiricalSrc: string = '';
    mainSpiricalSrcUpdated: boolean = false;
    proj: any;
    isUrl: any = false;
    currentFlats: any;
    currentFlatsOnClick: any;
    currentFlatsOnClickShow: boolean = false;
    toggleMenuTab: boolean = false;
    desktopResolution: boolean = true;
    panoramaView: any;
    fulWidthPanel: boolean = false;
    @Input() appartments: string;
    @Input() building: any;
    @Output() flatSelected = new EventEmitter<any>();  // Emit selected flat data to the parent
    @Output() public isOnTheFly = new EventEmitter();
    shareflatgallery: boolean = true;
    shareflatgalleryOfBuilding: boolean = true;
    simpleGallery: boolean = true;
    plan: boolean = true;
    routeNavigate: any;
    showPhone: boolean = false;
    showPhoneNumber: boolean = false;
    areaCode: string = '+972';
    areaCodes: any[] = ['+972', '+7', '+357', '+380', '+1', '+995'];
    freeText: string = '';
    titleWhatsapp: string;
    projTile: string;
    buildingTile: string;
    title: string;
    companyTitle: '';
    compTitle: string = '';
    propertyName: string = "";
    textWhatsapp1: string = "";
    textWhatsapp2: string = "";
    phoneNumber: number;
    showCopyNote: boolean = false;
    buildType: string = "";
    withDrawing: boolean = false;
    curFloorId: string = '';
    buildUid: string = '';
    galCounter: number = 0;

    constructor(
            private dataService: DataService,
            private route: ActivatedRoute,
            private titleService: Title,
            private translate: TranslateService,) {
    }


    ngOnInit(): void {
        this.textWhatsapp1 = this.translate.instant('TEXT-WHATSAP-1');
        this.textWhatsapp2 = this.translate.instant('TEXT-WHATSAP-2');
        this.propertyName = this.translate.instant('PROPERTY-NAME');
        this.compTitle = this.dataService.hoisUrlGetTitle();
        this.buildingTile = this.building.name;
        // this.getFlat('');
        this.buildType = this.building.buildType;
        this.buildUid = this.building.uid
        if (window.innerWidth < 1200) {
            this.desktopResolution = false;
        }
        this.dataService.getSpecProject(this.route.snapshot.paramMap.get('idp')).subscribe(proj => {
            this.proj = proj;
        });
        this.dataService.currentFlatsPanelOnClickShow.subscribe(item => {
            this.currentFlatsOnClickShow = item;
        })
        this.dataService.getSpecProject(this.route.snapshot.paramMap.get('idp')).subscribe(proj => {
            // this.projUid = proj[0].uid;
            this.projTile = proj[0].title;
            this.companyTitle = proj[0].companyTitle;
            // this.pageTitle();
            console.log(proj[0].title)
            setTimeout(() => {
                this.pageTitle();
            }, 1000);

        })
    }

    showPhoneF() {
        this.showPhone = !this.showPhone;
        if (this.showPhone) {
            this.showPhoneNumber = false;
        }
    }

    onChangeAreaCode(code) {
        this.areaCode = code
    }

    pageTitle() {
        if (this.projTile) {
            if (this.buildingTile) {
                // this.title = 'Spirikal' + ' - ' + this.compTile + ' - ' + this.projTile + ' - ' + this.buildingTile;
                if (this.currentFlatsOnClick) {
                    let flat: any = this.currentFlatsOnClick;
                    this.routeNavigate = 'https://spirical.net' + location.pathname + '/' + flat.id + "?m=n";
                    if (flat) {
                        this.title = this.companyTitle + ' - ' + this.projTile + ' - ' + this.buildingTile + ' / דירה ' + flat.number;
                        this.titleWhatsapp = this.compTitle + '%0a' + this.companyTitle + '%0a' + this.projTile + '%0a' + this.buildingTile + '%0a' + this.propertyName + flat.number + '\n';
                    }
                }
                this.titleService.setTitle(this.title);
            }
        }
    }

    whatsapMessageSend() {
        // let url = window.location.origin + '/company/u/' + this.route.snapshot.paramMap.get('id') + '/' + projUid ;
        let url = 'https://api.whatsapp.com/send?text=' + this.freeText + '%0a' + this.titleWhatsapp + '%0a' + this.textWhatsapp1 + '%0a' + this.routeNavigate + '%0a' + '%0a' + this.textWhatsapp2 + '%0a' + this.projTile + '%0a' + '&phone=' + this.areaCode + this.phoneNumber;
        window.open(url, '_blank');
    }


    copyInputMessage(inputElement) {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
        this.showCopyNote = true;
        let showCopyNote = this.showCopyNote;
        setTimeout(() => {
            this.showCopyNote = false;
        }, 3000);
    }

    stopPropagationF($event) {
        $event.stopPropagation();
        $event.preventDefault();
        let canvas = document.getElementsByTagName('canvas')[0];
    }

    togglePanel() {
        this.currentFlatsOnClickShow = !this.currentFlatsOnClickShow;
        this.fulWidthPanel = false;
        this.dataService.savecurrentFlatsPanelOnClickShow(this.currentFlatsOnClickShow);
        this.isOnTheFly.emit(this.currentFlatsOnClickShow);
        this.dataService.saveFullWidthPropertiesFlatPanel(false);
    }

    closePanel() {
        this.currentFlatsOnClickShow = false;
        this.fulWidthPanel = false;
        this.dataService.savecurrentFlatsPanelOnClickShow(false);
        this.isOnTheFly.emit(false);
        this.dataService.saveFullWidthPropertiesFlatPanel(false);
    }

    bigPanel() {
        this.fulWidthPanel = !this.fulWidthPanel;
        this.dataService.saveFullWidthPropertiesFlatPanel(this.fulWidthPanel);
    }

    // openMenuMatTab(gal?) {
    //   // fix after translate - gallery view in mobile;
    //   // this.panoramaView = this.building.floors[0].floor.panoramaView;
    //   this.toggleMenuTab = !this.toggleMenuTab;
    //   if (gal === 'gal' && !this.toggleMenuTab) {
    //     // this.galCounter = this.galCounter + 1;
    //   }

    // }

    openMenuMatTab(gal?) {
        // fix after translate - gallery view in mobile;
        this.toggleMenuTab = !this.toggleMenuTab;
        if (gal === 'gal' && !this.toggleMenuTab) {
            this.galCounter = this.galCounter + 1;
        }
    }

    getFlat(appartments, clientX, clientY) {
        let floors = this.building.floors;
        let selectedFlat = null;

        if (appartments) {
            floors.forEach(floor => {
                let currentFlats = floor.floor.flats.filter(flat => {
                    if (flat.number + '' === appartments + '') {
                        this.currentFlats = flat;
                        selectedFlat = flat; // Store the selected flat to emit
                        this.flatSelected.emit(selectedFlat);
                        return flat;
                    }
                });
            });
            //        // Emit the selected flat back to the parent component
            //  if (selectedFlat) {
            //   this.flatSelected.emit(selectedFlat);
            // }
        }


        /*let elem = document.getElementById('data-on-the-fly');
        // elem.style.transform = 'translate('+ clientX +',' + clientY + ')';
        clientX = clientX + 70;
        if (elem) {
            elem.style.transform = 'translate(' + '-' + clientX + 'px, ' + clientY + 'px)';
        }*/
    }

    projPassFromMenu() {
        // this.proj = proj;
        let str = this.proj[0].spirical
        str = str.slice(str.indexOf('src') + 5);
        this.mainSpiricalSrc = str.slice(0, str.indexOf('"'));
        this.mainSpiricalSrcUpdated = true;
    }

    isNoItemsF($event, wichGallery) {
        if (wichGallery === 'shareflatgallery') {
            this.shareflatgallery = false;
        } else {
            this.simpleGallery = false;
        }
        if (wichGallery === 'shareflatgalleryOfBuilding') {
            this.shareflatgalleryOfBuilding = false;
        } else {
            this.simpleGallery = false;
        }
        if (wichGallery === 'plan') {
            this.plan = !$event;
        }

        console.log('no Items');
    }

    getFlatOnClick(appartments) {
        // this.dataService.curProjects.subscribe(items => {
        //   this.proj = items;
        //   this.projPassFromMenu();
        // })
        console.log(appartments);
        this.projPassFromMenu();
        let floors = this.building.floors;
        if (appartments) {
            floors.forEach(floor => {
                let currentFlats = floor.floor.flats.filter(flat => {
                    if (flat.number + '' === appartments + '') {
                        this.currentFlatsOnClick = flat;
                        this.pageTitle();
                        this.curFloorId = floor.floor.id;
                        if (floor.withDrawing) {
                            this.withDrawing = floor.withDrawing;
                        }
                        this.panoramaView = floor.floor.panoramaView;
                        if (flat.faltPrototype !== '' || flat.faltPrototype !== undefined) {
                            this.dataService
                                    .getSpecFlatPrototypeView(flat.faltPrototype)
                                    .subscribe(prototype => {
                                        this.currentFlatsOnClick.protoId = prototype[0].id;
                                        this.currentFlatsOnClick.flatInterior = prototype[0].flatInterior;
                                    });
                        }
                        this.currentFlatsOnClickShow = true;
                        this.dataService.savecurrentFlatsPanelOnClickShow(this.currentFlatsOnClickShow);
                        if (flat.curFloorPanorama) {
                            if (flat.curFloorPanorama.hostname) {
                                this.isUrl = true;
                            }
                        }
                        return flat;
                    }
                });
            });
        }
    }

    ifFloorIdIsFloorNumber(floorId) {
        const numberString = floorId.toString();
        if (numberString.length < 5) {
            return true;
        } else {
            return false;
        }
    }


}
